import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb50f8e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editable-input" }
const _hoisted_2 = ["value"]

import { computed } from 'vue'
import tinycolor, { type ColorFormats } from 'tinycolor2'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditableInput',
  props: {
    value: {}
  },
  emits: ["colorChange"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const val = computed(() => {
  let _hex = ''
  if (props.value.a < 1) _hex = tinycolor(props.value).toHex8String().toUpperCase()
  else _hex = tinycolor(props.value).toHexString().toUpperCase()
  return _hex.replace('#', '')
})

const handleInput = (e: Event) => {
  const value = (e.target as HTMLInputElement).value
  if (value.length >= 6) emit('colorChange', tinycolor(value).toRgb())
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      class: "input-content",
      value: val.value,
      onInput: _cache[0] || (_cache[0] = $event => handleInput($event))
    }, null, 40, _hoisted_2)
  ]))
}
}

})